import type { CSSProperties } from 'react';
import styles from './SurfaceHeader.module.css';

/** The padding tokens a chat surface card uses. The card passes the same one
 *  to its header band, so the band always cancels exactly that padding. */
export type SurfacePadding = 'sm' | 'md' | 'lg';

/**
 * Props that turn a surface's existing title row into its header band: a
 * subtle background like a table's header row, running edge to edge. The row
 * must be the card's first child, and `padding` must be the card's own `p`.
 *
 * `below` is the space under the band, the card's padding by default. Pass
 * `'none'` when what follows already spaces itself (a `Stack` gap, or a body
 * with its own top margin), or a smaller token for a subline that belongs
 * close under the title.
 */
export type SurfaceBelow = SurfacePadding | 'none';

const belowValue = (below: SurfaceBelow): string =>
  below === 'none' ? '0' : `var(--mantine-spacing-${below})`;

export const surfaceHeaderProps = (
  padding: SurfacePadding,
  below: SurfaceBelow = padding
): { className: string; style: CSSProperties } => ({
  className: styles.header,
  style: {
    '--surface-pad': `var(--mantine-spacing-${padding})`,
    '--surface-below': belowValue(below),
  } as CSSProperties,
});
